export default __webpack_public_path__ + "static/media/AR.82c0c72e.svg";